import React, { lazy, Suspense } from 'react';

const ActionableTaskView = lazy(() =>
  import(/* webpackChunkName: "actionable-task-view" */ './ActionableTaskView'),
);

export const LazyActionableTaskView: React.FunctionComponent = () => {
  return (
    <Suspense fallback={null}>
      <ActionableTaskView />
    </Suspense>
  );
};
